<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-switch
                        @change="changehWeightingDerail()"
                        v-model="weightDerail"
                        active-value='1'
                        inactive-value='0'
                        active-text="加权开"
                        inactive-text="加权关">
                    </el-switch>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" @change="searchWeightingList()"/>
                </div>

                <div class="common-header-block">
                    <el-input
                            class="common-el-input"
                            placeholder="输入玩家昵称或ID查询"
                            v-model="searchVal">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="searchWeightingList()">搜索</el-button>
                </div>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userWeightingList.beanList"
                    height="100%"
                    >
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" align="center" prop="userNickname" width="150"/>
                <el-table-column label="玩家ID" align="center" prop="userRandomId" width="150"/>
                <el-table-column label="加权种类" align="center" prop="weightCode" width="150">
                    <template slot-scope="scope">
                        <p v-if="scope.row.weightCode == 1">
                            永久注销加权
                        </p>
                        <p v-else-if="scope.row.weightCode == 2">
                            新用户加权
                        </p>
                        <p v-else-if="scope.row.weightCode == 3">
                            浅水加权
                        </p>
                        <p v-else-if="scope.row.weightCode == 4">
                            深水加权
                        </p>
                        <p v-else-if="scope.row.weightCode == 5">
                            回归加权
                        </p>
                        <p v-else-if="scope.row.weightCode == 6">
                            手工加权
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="加权内容" width="150" align="center" prop="interventionType">
                    <template slot-scope="scope">
                        <p v-if="scope.row.interventionType == 1">
                            冤家牌
                        </p>
                        <p v-else-if="scope.row.interventionType == 2">
                            翻牌前干预
                        </p>
                        <p v-else-if="scope.row.interventionType == 6">
                            翻牌干预
                        </p>
                        <p v-else-if="scope.row.interventionType == 30">
                            翻牌后干预-第4张牌
                        </p>
                        <p v-else-if="scope.row.interventionType == 31">
                            翻牌后干预-第5张牌
                        </p>
                        <p v-else-if="scope.row.interventionType == 4">
                            Allin落后逆转（爆牌
                        </p>
                        <p v-else-if="scope.row.interventionType == 5">
                            Allin领先不逆转
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="加权干预次数" width="180" align="center" prop="interventionNum"/>
                <el-table-column label="加权当手盈亏" align="center">
                  <template slot-scope="scope">{{scope.row.handPl|numberChip}}</template>
                </el-table-column>
                <el-table-column label="加权牌局" align="center" prop="roomName"/>
                <el-table-column label="加权时间" align="center" width="150" prop="interventionTime"/>
                    
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="userWeightingList.total"
                :current-page="currentPage"
                @current-change="searchWeightingList({page:$event})"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import utils from "../../../utils/util.js";

    export default {
        components:{
            // compClubConfig
        },
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
                configInfo:{},
                currentPage: 1,
                weightDerail:0
            }
        },
        computed: {
            ...mapState('user', ['userWeightingList','userWeightingStatus']),
            userType() {
                return localStorage.getItem('authTypeCode')
            }
        },
        created() {
            this.date = utils.getToday();
            this.searchWeightingList();
            this.searchWeightingDerail();
        },
        methods: {
             ...mapActions('user', ['getUserWeightingList','changeWeighting','searchWeightingStatus']),
            // 加权数据统计列表
            searchWeightingList(obj = {}) {
                this.loading = true;
                let params = {
                    userRandomIdOrNickname: this.searchVal,
                    startTime: this.date ? this.date[0] : '',
                    endTime: this.date ? this.date[1] : '',
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getUserWeightingList(params).then(() => {
                    this.loading = false;
                })
            },
            changehWeightingDerail(obj = {}){
                let params = {
                    status: this.weightDerail
                };
                Object.assign(params, obj);
                this.changeWeighting(params).then(() => {

                })
            },
            searchWeightingDerail(obj = {}){
                var self = this;
                let params = {
                    // status: this.userWeightingStatus
                };
                Object.assign(params, obj);
                this.searchWeightingStatus(params).then(() => {
                    self.weightDerail = self.userWeightingStatus.toString();
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    :global(.el-icon-edit-outline) {
        color: $theme-color;
        cursor: pointer;
    }
</style>